var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ScrollContext',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDisplayed),expression:"isDisplayed"}],staticClass:"activity-feed"},_vm._l((_vm.entries),function(entry){return _c(_vm.activityFeedComponents[entry.verb],{key:entry.id,tag:"Component",staticClass:"activity-feed__item",attrs:{"entry":entry}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }